// modules
import { createAction } from 'redux-actions'
// setup
import { dispatch } from '$setup/redux'

export const DROP_ZONE_SET_IS_OPEN = 'DROP_ZONE_SET_IS_OPEN'
export const dropZoneSetIsOpen = createAction(DROP_ZONE_SET_IS_OPEN)
export const dispatchDropZoneSetIsOpen = (...args) =>
  dispatch(dropZoneSetIsOpen(...args))
